import React from "react";
import { Dialog, DialogContent, Grid } from "@mui/material";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import PlacementTestingForm from "../../CcpSchool/CcpSchoolAppsAndTesting/inc/PlacementTestingForm";
import NewCourseRequest from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/NewCourseRequest";
import ChangeCourseRequest from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/ChangeCourseRequest";
import StudentDropForm from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/StudentDropForm";
import CourseProctorForm from "../../CcpSchool/CcpSchoolRestrictedCourses/inc/CourseProctorApp";
import StudentChangeForm from "../../CcpSchool/CcpSchoolAppsAndTesting/inc/StudentChangeForm";

const DistrictSchoolForms = ({ open, onClose, schoolId }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <ModalDialogTitle onClose={onClose}>School Forms</ModalDialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <NewCourseRequest schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={3}>
            <ChangeCourseRequest schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={3}>
            <CourseProctorForm schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={3}>
            <StudentDropForm schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={3}>
            <StudentChangeForm schoolId={schoolId} />
          </Grid>{" "}
          <Grid item xs={12} md={6}>
            <PlacementTestingForm schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={6}></Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DistrictSchoolForms;
